import { useContext, useEffect, useState } from "react";
import TextareaAutosize from "react-textarea-autosize";
import { MdOutlineAttachment } from "react-icons/md";
import { TbSend } from "react-icons/tb";

import { ChatContext } from "src/contexts/chat.context";

import "./message-input.style.scss";

const MessageInput = () => {
	const { sendMessage, selectedChat } = useContext(ChatContext);
	const [message, setMessage] = useState("");

	const otherId = selectedChat?.userId;
	const matchId = selectedChat?.matchId;

	useEffect(() => {
		setMessage("");
	}, [selectedChat]);

	const handleChange = (event) => {
		const text = event.target.value;
		setMessage(text);
	};

	const handleSend = () => {
		sendMessage(message, otherId, matchId);
		setMessage("");
	};

	return (
		<div className="input-container">
			<div className="attachment-button">
				<MdOutlineAttachment />
			</div>
			<TextareaAutosize className="text-area" maxRows={5} value={message} onChange={handleChange} />
			<div onClick={handleSend} className="send-button">
				<TbSend />
			</div>
		</div>
	);
};

export default MessageInput;
